<template>
  <div>
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="archive-main">
      <div class="arm-head">
        <img src="../../assets/images/titleimg.png" alt="" /> Hot Keywords In
        <div
          class="arm-head-btn"
          :class="yearindex == 0 ? 'arm-head-btn-act' : ''"
          @click="changeyear(0)"
        >
          标题
        </div>
        <div
          class="arm-head-btn"
          :class="yearindex == 1 ? 'arm-head-btn-act' : ''"
          @click="changeyear(1)"
        >
          摘要
        </div>
        <div
          class="arm-head-btn"
          :class="yearindex == 2 ? 'arm-head-btn-act' : ''"
          @click="changeyear(2)"
        >
          关键词
        </div>
      </div>
      <div class="arm-body">
        <div class="arm-left">
          <div
            class="arm-left-main"
            :class="leftfixed ? 'arm-left-main-fixed' : ''"
            v-if="leftdata"
          >
            <div class="alm-titile">
              <div
                class="almt-sec"
                :class="isccf ? 'almt-sec-act' : ''"
                @click="changeccf(true)"
              >
                信息科学部
              </div>
              <!-- <div
                class="almt-sec"
                :class="!isccf ? 'almt-sec-act' : ''"
                @click="changeccf(false)"
              >
                IEEE
              </div> -->
            </div>
            <div class="alm-body">
              <div v-for="(i, index) in lefttitles" :key="i.id">
                <div
                  class="almb-sec"
                  :class="leftindex == index ? 'almb-sec-act' : ''"
                  @click="handleleftsec(i.name, index)"
                >
                  {{ i.id }} {{ i.name }}
                </div>

                <div class="almb-sec-list" v-if="leftindex == index">
                  <div
                    class="almbsl-item"
                    :class="actitem == item.name ? 'almbsl-item-act' : ''"
                    @click="handlealmitem(i.name, item.name)"
                    v-for="item in i.child"
                    :key="item.id"
                  >
                    {{ item.id }} {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="alm-body" v-if="!isccf && leftdata.IEEE">
              <div
                class="almb-sec"
                :class="leftindex == index ? 'almb-sec-act' : ''"
                @click="handleleftsec(key, index)"
                v-for="(i, key, index) in leftdata.IEEE.rank"
                :key="key"
              >
                {{ key }}
              </div>
            </div> -->
          </div>
        </div>
        <div class="arm-right" v-if="leftdata">
          <div class="armr-top">
            <div class="armrt-head">
              <span v-if="isccf">信息科学部</span>
              <!-- <span v-if="!isccf">IEEE Category</span> -->
            </div>
            <div class="armrt-body" v-if="leftdata">
              <span>
                本网页是上海交通大学Acemap团队根据国家自然科学基金公开数据，汇总分析得出的各年份信息学部立项基金标题、摘要、中文关键词中高频热点关键词趋势，提供研究方向的参考。
                如果您有任何改进建议，欢迎您联系我们</span
              ><span
                class="armrt-a"
                @click="opennew('mailto:acemap@cs.sjtu.edu.cn')"
                >acemap@cs.sjtu.edu.cn。</span
              >
            </div>
          </div>
          <div v-if="leftdata">
            <div class="armr-main" :class="leftdata.category">
              <div class="armrt-head">
                <span>{{ leftdata.foundation }}</span>
              </div>
              <div class="cloudwrapper">
                <div class="cloud-fixed" v-show="showfixed">
                  <div class="cloud-fixed-tab">
                    <el-button @click="changetab(2)">circle</el-button>
                  </div>
                  <div class="cloud-fixed-tab">
                    <el-button @click="changetab(0)">cloud</el-button>
                  </div>
                  <div class="cloud-fixed-tab">
                    <el-button @click="changetab(1)">tree</el-button>
                  </div>
                  <div class="cloud-fixed-tab">
                    <el-button @click="changetab(3)">tree cloud</el-button>
                  </div>
                </div>

                <div
                  :class="showwordcloud || tabindex == 0 ? 'showcloud' : ''"
                  class="cloud-con"
                >
                  <div :id="'cloudEl'" class="cloud-box"></div>
                </div>

                <div
                  v-show="showwordcloud || tabindex == 0"
                  class="cloud-block"
                ></div>
                <Map
                  v-show="!showwordcloud && tabindex == 1"
                  :mapid="mapid"
                  v-on:setSelectedNode="getSelectedNode"
                />
                <div
                  class="newcircle-wrap"
                  v-if="!showwordcloud && tabindex == 2"
                >
                  <div class="newcircle" id="newcircle">
                    <div id="dot" class="newcircle-itemdot">{{ actitem }}</div>
                    <div
                      class="newcircle-item"
                      v-for="(i, index) in demolist.children"
                      :key="i.id"
                      :id="'circleword' + index"
                    ></div>
                  </div>
                </div>
                <div
                  v-show="!showwordcloud && tabindex == 3"
                  class="cloudtree-con"
                >
                  <div class="cloudtree-center">{{actitem}}</div>
                  <div class="clouditem-con">
                    <div :id="'cloudtreeEl'+index" v-for="(i, index) in demolist.children"
                      :key="i.id" class="cloudtree-box"></div>
                  </div>
                  <div class="canvas-con">
                    <canvas v-for="(i,index) in demolist.children" :key="i.id+'line'" class="cloudline" :id="'linecanvas'+index" width=200 height=200 ></canvas>
                  </div>
                </div>
                <!-- <div
                  v-show="!showwordcloud && tabindex == 2"
                  id="containernew"
                ></div> -->
              </div>

              <div class="armrm-body">
                <div class="armrm-btnbox">
                  <el-button v-if="!showranktable" @click="clickshowratio2"
                    >变化趋势</el-button
                  >
                  <el-button v-else @click="clickshowratio">基金数量</el-button>
                </div>
                <el-table
                  :data="leftdata.rank"
                  v-if="showranktable"
                  stripe
                  @expand-change="
                    (...event) => {
                      exchange(event, leftdata.category, leftdata.foundation);
                    }
                  "
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div
                        :class="'tablecontz' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div
                        :class="'tablecontzhu' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div class="table-author">
                        <p>相关作者</p>
                        <div class="table-author-wrap">
                          <div
                            class="table-author-item"
                            v-for="(i, index) in scope.row.author"
                            :key="i.author"
                          >
                            {{ i.unit }}:
                            <span :style="{ zIndex: 1000 - index }">
                              {{ i.author }}
                              <div class="tai-keyword" v-if="i.keyword">
                                <p v-for="item in i.keyword" :key="item">
                                  {{ item }}
                                </p>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="keyword" label="keyword" width="180">
                  </el-table-column>
                  <el-table-column prop="ratio" label="ratio" width="180">
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index2) in tabelhead[yearindex]"
                    :key="index2"
                  >
                    <template slot="header" slot-scope="scope">
                      {{ item }}
                    </template>
                    <template slot-scope="scope">
                      <span
                        :class="
                          scope.row[item].indexOf('-') >= 0 ? 'green' : 'red'
                        "
                        >{{ scope.row[item] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                  v-else
                  :data="nsfcdata"
                  stripe
                  @expand-change="
                    (...event) => {
                      exchange(event, leftdata.category, leftdata.foundation);
                    }
                  "
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div
                        :class="'tablecontz' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div
                        :class="'tablecontzhu' + scope.row.id"
                        class="zchart"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="keyword" label="keyword" width="180">
                  </el-table-column>
                  <el-table-column prop="2016" label="2016" width="180">
                    <template slot-scope="scope">
                      {{ scope.row[2016] == 0 ? "*" : scope.row[2016] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="2017" label="2017" width="180">
                    <template slot-scope="scope">
                      {{ scope.row[2017] == 0 ? "*" : scope.row[2017] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="2018" label="2018" width="180">
                    <template slot-scope="scope">
                      {{ scope.row[2018] == 0 ? "*" : scope.row[2018] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="2019" label="2019" width="180">
                    <template slot-scope="scope">
                      {{ scope.row[2019] == 0 ? "*" : scope.row[2019] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="2020" label="2020" width="180">
                    <template slot-scope="scope">
                      {{ scope.row[2020] == 0 ? "*" : scope.row[2020] }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="table-bottom">
                <div class="bottomspan">图中*为代码新增暂无数据</div>
                <div class="armrt-h-right">
                  <el-button @click="readmore" size="mini">更多</el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="!isccf && leftdata.IEEE">
            <div
              class="armr-main"
              :class="key"
              v-for="(i, key, index) in leftdata.IEEE.rank"
              :key="index"
            >
              <div class="armrt-head">
                <span>{{ key }}</span>
              </div>
              <div :id="'cloudEl'+index" class="cloud-box"></div>
              <div class="armrm-body armrm-body2">
                <el-table
                  :data="i"
                  stripe
                  @expand-change="exchange"
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div
                        :class="'tablecontz' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div
                        :class="'tablecontzhu' + scope.row.id"
                        class="zchart"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="keyword" label="keyword" width="180">
                  </el-table-column>

                  <el-table-column prop="ratio" label="ratio" width="180">
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index2) in tabelhead[yearindex]"
                    :key="index2"
                  >
                    <template slot="header" slot-scope="scope">
                      {{ item }}
                    </template>
                    <template slot-scope="scope">
                      <span
                        :class="
                          scope.row[item].indexOf('-') >= 0 ? 'green' : 'red'
                        "
                        >{{ scope.row[item] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="gotop-btn" v-if="leftfixed" @click="gotop">
      <img src="../../assets/images/top.png" alt="" />
    </div>
    <div class="right-box" v-if="showrightbox">
      <div class="rb-title">
        {{ rbtitle }}
        <el-button size="mini" class="bluebtn" @click="handleviewmore(rbtitle)"
          >View more</el-button
        >
        <span class="rb-close" @click="closerb">X</span>
      </div>
      <div class="rb-chart-con">
        <div class="rb-chart" id="rbchart"></div>
      </div>

      <div class="rb-funds">
        <div class="rb-title" v-if="rbfunds && rbfunds.length > 0">
          相关基金
        </div>
        <div class="rb-f-item" v-for="i in rbfunds" :key="i.title">
          <div class="rb-fi-title">
            {{ i.title }}
          </div>
          <div class="rb-fi-abs">
            {{ i.abstract }}
          </div>
        </div>
      </div>
      <div class="rb-liter">
        <div class="rb-title" v-if="rbliter && rbliter.length > 0">
          相关论文
        </div>
        <div class="rb-f-item" v-for="i in rbliter" :key="i.title">
          <div class="rb-fi-title">
            {{ i.title }}
          </div>
          <div class="rb-fi-abs">
            {{ i.abstract }}
          </div>
        </div>
      </div>
      <div class="rb-author">
        <div class="rb-title" v-if="rbfunds && rbfunds.length > 0">
          相关作者
        </div>
        <div class="rb-author-wrap">
          <div
            class="rb-author-item"
            v-for="(i, index) in rbauthor"
            :key="i.author"
          >
            {{ i.unit }}:
            <span :style="{ zIndex: 1000 - index }"
              >{{ i.author }}
              <div class="tai-keyword">
                <p v-for="item in i.keyword" :key="item">{{ item }}</p>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getfilter,
  getchart,
  getfund,
  getwordcloud,
  getauthor,
} from "@/api/hotkeyword2";
import { Chart } from "@antv/g2";
import * as echarts from "echarts";
import Map from "../fund/Map";
import G6 from "@antv/g6";
import mapData1 from "./mapjson/f01";
import mapData2 from "./mapjson/f02";
import mapData3 from "./mapjson/f03";
import mapData4 from "./mapjson/f04";
import mapData5 from "./mapjson/f05";
import mapData6 from "./mapjson/f06";
import mapData7 from "./mapjson/f07";
import demo from "./mapjson/demo";
import demo2 from "./mapjson/demo2";
import demo3 from "./mapjson/demo3";
import demo4 from "./mapjson/demo4";
import demo5 from "./mapjson/demo5";
import demo6 from "./mapjson/demo6";
import demo7 from "./mapjson/demo7";
import cloudpng from "./cloudnew.jpeg";

export default {
  data() {
    return {
      tableData: [],
      leftdata: [],
      rightdata: [],
      yearindex: 0,
      showranktable: true,
      alldata: [],
      rbauthor: [],
      tableauthor: [],
      actitem: "电子学与信息系统",
      actcat: "电子学与信息系统",
      isccf: true,
      leftfixed: false,
      leftindex: 0,
      showwordcloud: false,
      wordCloudData: null,
      showrightbox: false,
      showfixed: true,
      rbtitle: "",
      rbfunds: [],
      rbliter: [],
      tabindex: 2,
      demolist: {},
      mapid: 0,
      rightchart: null,
      tabelhead: [
        ["2016-2017", "2017-2018", "2018-2019", "2019-2020"],
        ["2014-2015", "2015-2016", "2016-2017", "2017-2018"],
        ["2014-2015", "2015-2016", "2016-2017", "2017-2018"],
      ],
      showlist: [],
      lefttitles: [],
      ismore: false,
      mapdata: [],
      graph: null,
      cloudpng64: "",
    };
  },
  components: {
    Map,
  },
  mounted() {
    document.title = "NSFC Keywords";

    this.hotgetfund();
    if (localStorage.getItem("hotkeyfund")) {
      if (localStorage.getItem("hotkeyfund") == "title") {
        this.yearindex = 0;
      } else if (localStorage.getItem("hotkeyfund") == "abstract") {
        this.yearindex = 1;
      } else {
        this.yearindex = 2;
      }
      this.getdata(
        localStorage.getItem("hotkeyfund"),
        "电子学与信息系统",
        "电子学与信息系统",
        false
      );
    } else {
      this.getdata("title", "电子学与信息系统", "电子学与信息系统", false);
    }
    this.initdemodata(demo, 0);
    let that = this;
    window.onscroll = function () {
      let scrolltop = document.documentElement.scrollTop;
      if (scrolltop >= 130) {
        that.leftfixed = true;
      } else {
        that.leftfixed = false;
      }
    };

    setTimeout(() => {
      this.getmapdata(mapData1);
    }, 500);
  },
  methods: {
    opennew(url) {
      window.open(url);
    },
    handleviewmore(e) {
      console.log(e, "---452");
      this.$router.push({
        name: "detail",
        query: {
          name: e,
        },
      });
    },
    drawlinecanvas(index,startx,starty,endx,endy,cx1,cy1,cx2,cy2) {
      var canvas=document.getElementById('linecanvas'+index);
        var context=canvas.getContext('2d');        
       context.moveTo(startx, starty)
        context.bezierCurveTo(cx1, cy1, cx2, cy2, endx, endy)
        context.stroke()
    },
    inittreeclouddata(data, findex) {
      // console.log(data,'---498')
      this.demolist = {};
      for (let i = 0; i < data.length; i++) {
        this.demolist = {
          id: data[i].id,
          name: data[i].name,
          children: data[i].children,
        };
      }
      for (let i = 0; i < this.demolist.children.length; i++) {
        this.demolist.children[i].newlist = [];
        this.demolist.children[i].newlist.push({
          id: this.demolist.children[i].id,
          name: this.demolist.children[i].name,
          value: 100,
          index: 1,
        });
        if (
          this.demolist.children[i].children &&
          this.demolist.children[i].children.length > 0
        ) {
          this.changedemodata(
            this.demolist.children[i],
            this.demolist.children[i].newlist,
            2
          );
        }
      }
      // console.log(this.demolist,'---481')
      let that = this;
      this.$nextTick().then(function () {
        for (let i = 0; i < that.demolist.children.length; i++) {
          let str = "cloudtreeEl" + i;
          let el = document.getElementById(str);
          // console.log(str,el,'---499')
          // that.initcircle(findex);
          
          if(i==0){
            that.drawlinecanvas(i,10,30,130,150,0,50,160,100)
          }else if(i==1){
            that.drawlinecanvas(i,0,100,180,170,50,50,160,180)
          }
          else if(i==2){
            that.drawlinecanvas(i,80,200,150,190,90,150,140,200)
          }
          else if(i==3){
            that.drawlinecanvas(i,130,150,200,70,140,150,160,70)
          }
          else if(i==4){
            that.drawlinecanvas(i,80,0,10,130,100,30,10,50)
          }
          else if(i==5){
            that.drawlinecanvas(i,100,100,40,150,100,110,40,100)
          }
          else if(i==6){
            that.drawlinecanvas(i,170,150,0,100,170,160,50,100)
          }
          else if(i==7){
            that.drawlinecanvas(i,90,140,0,60,100,150,0,100)
          }

          that.drawtreeCloud(el, that.demolist.children[i].newlist);
        }
      });
    },
    initdemodata(data, findex) {
      // console.log(data,'---498')
      this.demolist = {};
      for (let i = 0; i < data.length; i++) {
        this.demolist = {
          id: data[i].id,
          name: data[i].name,
          children: data[i].children,
        };
      }
      for (let i = 0; i < this.demolist.children.length; i++) {
        this.demolist.children[i].newlist = [];
        this.demolist.children[i].newlist.push({
          id: this.demolist.children[i].id,
          name: this.demolist.children[i].name,
          value: 100,
          index: 1,
        });
        if (
          this.demolist.children[i].children &&
          this.demolist.children[i].children.length > 0
        ) {
          this.changedemodata(
            this.demolist.children[i],
            this.demolist.children[i].newlist,
            2
          );
        }
      }
      // console.log(this.demolist,'---481')
      let that = this;
      this.$nextTick().then(function () {
        for (let i = 0; i < that.demolist.children.length; i++) {
          let str = "circleword" + i;
          let el = document.getElementById(str);
          // console.log(str,el,'---499')
          that.initcircle(findex);
          that.drawCloudcircle(el, that.demolist.children[i].newlist);
        }
      });
    },
    drawCloudcircle(wrapEl, data) {
      // let maskImage = new Image(); //可以根据图片形状生成有形状的词云图
      // maskImage.src= this.bgImg;
      // let list = [];
      // for (let i in data) {
      //   list.push({
      //     name: i,
      //     value: data[i],
      //   });
      // }
      // // console.log(list,'---310')
      // if (list.length == 0) {
      //   list = [{ name: "无", value: 50 }];
      // }
      let myChart = echarts.init(wrapEl);
      // const color = [
      //     'rgb(46,41,39)','rgb(16, 16, 218)','rgb(10,110,116)','rgb(119,122,96)','rgb(101,134,71)','rgb(141,138,134)'
      // ];
      const color = [
        "rgb(46,41,39)",
        "rgb(67,101,41)",
        "rgb(10,110,116)",
        "rgb(119,122,96)",
        "rgb(101,134,71)",
        "rgb(141,138,134)",
        "rgb(46,41,39)",
      ];
      let option = {
        tooltip: {
          show: true,
        },
        // backgroundColor:'#fff', // 画布背景色
        series: [
          {
            name: "热词",
            type: "wordCloud",
            // maskImage: maskImage, // 图片形状
            keepAspect: false,
            shape: "circle",
            sizeRange: [10, 20], //画布范围,如果设置太大会出现少词（溢出屏幕）
            rotationRange: [0, 0], //数据翻转范围
            // shape: "circle",
            // drawOutOfBound: true, // 超出画布的词汇是否隐藏
            drawOutOfBound: false,
            color: "#fff",
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            // width: "100%",
            height: "100%",
            gridSize: 2,
            textPadding: 10,
            autoSize: {
              enable: true,
              minSize: 2,
            },
            textStyle: {
              normal: {
                fontFamily: "sans-serif",
                fontWeight: "bold",
                // color: "#333", // 字体颜色
                color: function (e) {
                  // console.log(e.data.index,'---572')
                  // 字体颜色
                  return color[e.data.index];
                  // return (
                  //   "rgb(" +
                  //   [
                  //     Math.round(Math.random() * 160),
                  //     Math.round(Math.random() * 160),
                  //     Math.round(Math.random() * 160),
                  //   ].join(",") +
                  //   ")"
                  // );
                },
              },
              emphasis: {
                // focus: 'self',
                textStyle: {
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
            },
            data: data,
          },
        ],
      };
      // maskImage.onload = function() {
      let that = this;
      myChart.setOption(option, true);
      // console.log(myChart, "---495");
      myChart.on("click", function (e) {
        // console.log(e, "----401");
        that.clickwordcloud(e.data.name);
      });
      // };
    },
    initcircle(findex) {
      //中心点横坐标
      let dot = document.getElementById("dot");
      // var dotLeft = (document.getElementById('nav').offsetWidth - dot.offsetWidth) / 2;
      let dotLeft =
        document.getElementById("newcircle").offsetWidth / 2 -
        dot.offsetWidth / 2;
      //中心点纵坐标
      // var dotTop = (document.getElementById('nav').offsetHeight - dot.offsetHeight) / 2;
      var dotTop =
        document.getElementById("newcircle").offsetHeight / 2 -
        dot.offsetHeight / 2;
      console.log(
        document.getElementById("newcircle").offsetWidth / 2,
        dotLeft,
        dotTop,
        "---613"
      );
      //起始角度
      var stard = 0;
      //半径
      var radius = 250;
      //每一个BOX对应的角度;
      var avd =
        360 / document.getElementsByClassName("newcircle-item").length + stard;
      //每一个BOX对应的弧度;
      var ahd = (avd * Math.PI) / 180;
      //
      dot.style.position = "absolute";
      dot.style.left = dotLeft + "px";
      dot.style.top = dotTop + "px";
      let boxes = document.getElementsByClassName("newcircle-item");
      //  dot.css({ "left": dotLeft, "top": dotTop });
      if (findex == 0) {
        for (let index = 0; index < boxes.length; index++) {
          if (index == 5) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd6 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd6 = (avd6 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd6 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd6 * index) * radius + dotTop + "px";
          } else if (index == 7) {
            let avd7 =
              360 / document.getElementsByClassName("newcircle-item").length -
              1 +
              stard;
            let ahd7 = (avd7 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd7 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd7 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd1 =
              360 / document.getElementsByClassName("newcircle-item").length +
              10 +
              stard;
            let ahd1 = (avd1 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd1 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd1 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 1) {
        radius = 290;
        for (let index = 0; index < boxes.length; index++) {
          if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 7) {
            let avd6 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.7 +
              stard;
            let ahd6 = (avd6 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd6 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd6 * index) * radius + dotTop + "px";
          } else if (index == 8) {
            let avd7 =
              360 / document.getElementsByClassName("newcircle-item").length -
              1.6 +
              stard;
            let ahd7 = (avd7 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd7 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd7 * index) * radius + dotTop + "px";
          } else if (index == 9) {
            let avd7 =
              360 / document.getElementsByClassName("newcircle-item").length -
              1 +
              stard;
            let ahd7 = (avd7 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd7 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd7 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd1 =
              360 / document.getElementsByClassName("newcircle-item").length +
              10 +
              stard;
            let ahd1 = (avd1 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd1 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd1 * index) * radius + dotTop + "px";
          } else if (index == 5) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              4 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              4.5 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              5 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd4 =
              360 / document.getElementsByClassName("newcircle-item").length +
              8 +
              stard;
            let ahd4 = (avd4 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd4 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd4 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 2) {
        for (let index = 0; index < boxes.length; index++) {
          if (index == 7) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 3) {
        radius = 290;
        for (let index = 0; index < boxes.length; index++) {
          if (index == 7) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 5) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 4) {
        radius = 290;
        for (let index = 0; index < boxes.length; index++) {
          if (index == 7) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              1.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 5) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              7 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 5) {
        radius = 290;
        for (let index = 0; index < boxes.length; index++) {
          if (index == 7) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 5) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              7 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      } else if (findex == 6) {
        radius = 250;
        for (let index = 0; index < boxes.length; index++) {
          if (index == 7) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 6) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 5) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              2 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 4) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 3) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length -
              0.5 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 2) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              1 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else if (index == 1) {
            let avd5 =
              360 / document.getElementsByClassName("newcircle-item").length +
              7 +
              stard;
            let ahd5 = (avd5 * Math.PI) / 180;
            boxes[index].style.left =
              Math.sin(ahd5 * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd5 * index) * radius + dotTop + "px";
          } else {
            boxes[index].style.left =
              Math.sin(ahd * index) * radius + dotLeft + "px";
            boxes[index].style.top =
              Math.cos(ahd * index) * radius + dotTop + "px";
          }
        }
      }
    },
    changedemodata(e, arr, index) {
      // console.log(e,arr,'---484')
      for (let i = 0; i < e.children.length; i++) {
        arr.push({
          id: e.children[i].id,
          name: e.children[i].name,
          value: 100 - 10 * index,
          index: index,
        });
        if (e.children[i].children && e.children[i].children.length > 0) {
          this.changedemodata(e.children[i], arr, index + 1);
        }
      }
    },
    closerb() {
      this.showrightbox = false;
    },
    getSelectedNode(e) {
      console.log(e, "---331");
      this.clickwordcloud(e.name);
    },
    getIPs(callback) {
      var ip_dups = {};
      var RTCPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;
      var useWebKit = !!window.webkitRTCPeerConnection;
      var mediaConstraints = {
        optional: [{ RtpDataChannels: true }],
      };
      // 这里就是需要的ICEServer了
      var servers = {
        iceServers: [
          { urls: "stun:stun.services.mozilla.com" },
          { urls: "stun:stun.l.google.com:19302" },
        ],
      };
      var pc = new RTCPeerConnection(servers, mediaConstraints);
      function handleCandidate(candidate) {
        var ip_regex =
          /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
        var hasIp = ip_regex.exec(candidate);
        if (hasIp) {
          var ip_addr = ip_regex.exec(candidate)[1];
          if (ip_dups[ip_addr] === undefined) callback(ip_addr);
          ip_dups[ip_addr] = true;
        }
      }
      // 网络协商的过程
      pc.onicecandidate = function (ice) {
        if (ice.candidate) {
          handleCandidate(ice.candidate.candidate);
        }
      };
      pc.createDataChannel("");
      //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
      pc.createOffer(
        function (result) {
          pc.setLocalDescription(
            result,
            function () {},
            function () {}
          );
        },
        function () {}
      );
      setTimeout(function () {
        var lines = pc.localDescription.sdp.split("\n");
        lines.forEach(function (line) {
          if (line.indexOf("a=candidate:") === 0) handleCandidate(line);
        });
      }, 1000);
    },
    hotgetfund() {
      getfund().then((res) => {
        console.log(res, "---298");
        this.lefttitles = res.data;
      });
    },
    getmapdata(mapdata) {
      const container = document.getElementById("containernew");
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;
      this.graph = new G6.Graph({
        container: container,
        width,
        height,
        layout: {
          type: "radial",
          unitRadius: 100,
          preventOverlap: true,
          maxPreventOverlapIteration: 100,
          nodeSpacing: 400,
          linkDistance: 180,
          gpuEnabled: true,
        },
        defaultNode: {
          color: "#5B8FF9",
          style: {
            // "fill": "rgb(19, 30, 51)",
            // "stroke": "rgb(79, 125, 241)",
            // "cursor": "default",
            fillOpacity: 0,
            strokeOpacity: 0,
          },
          labelCfg: {
            style: {
              fontSize: 10,
            },
          },
        },
        defaultEdge: {
          type: "line",
          style: {
            stroke: "rgb(79, 79, 79)",
            cursor: "default",
            lineWidth: 0,
          },
        },
        modes: {
          default: ["drag-canvas", "zoom-canvas"],
        },
      });

      const data = mapdata;
      console.log(mapdata.nodes, "---432");
      const nodes = data.nodes;
      this.graph.data({
        nodes,
        edges: data.edges.map(function (edge, i) {
          edge.id = "edge" + i;
          return Object.assign({}, edge);
        }),
      });
      this.graph.render();
      this.graph.zoom(0.1);
      this.graph.fitView();
      let that = this;
      this.graph.on("node:click", function (e) {
        that.clickwordcloud(e.item._cfg.model.label);
      });
      // graph.on("node:drag", function (e) {
      //   refreshDragedNodePosition(e);
      // });
      // graph.on("node:dragend", function (e) {
      //   e.item.get("model").fx = null;
      //   e.item.get("model").fy = null;
      // });

      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!this.graph || this.graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          this.graph.changeSize(container.scrollWidth, container.scrollHeight);
        };

      function refreshDragedNodePosition(e) {
        const model = e.item.get("model");
        model.fx = e.x;
        model.fy = e.y;
      }
    },
    changemapdata(mapdata) {
      const data = mapdata;
      console.log(mapdata.nodes, "---432");
      const nodes = data.nodes;
      this.graph.data({
        nodes,
        edges: data.edges.map(function (edge, i) {
          edge.id = "edge" + i;
          return Object.assign({}, edge);
        }),
      });
      this.graph.render();
    },
    readmore() {
      let fund;
      if (this.yearindex == 0) {
        fund = "title";
      } else if (this.yearindex == 1) {
        fund = "abstract";
      } else if (this.yearindex == 2) {
        fund = "keyword";
      }
      this.getdata(fund, this.actcat, this.actitem, true);
    },
    clickwordcloud(e) {
      this.showrightbox = true;
      this.rbtitle = e;
      let fund;
      if (this.yearindex == 0) {
        fund = "title";
      } else if (this.yearindex == 1) {
        fund = "abstract";
      } else if (this.yearindex == 2) {
        fund = "keyword";
      }
      // this.getdata(fund,this.actcat,this.actitem,true)
      let params = {
        fund: fund,
        cat: this.actcat,
        foundation: this.actitem,
        keyword: e,
      };
      console.log(params, "---606");
      getwordcloud(params).then((res) => {
        this.rbfunds = res.data.related_funds;
        this.rbliter = res.data.related_literature;
        let wrapper = document.getElementsByClassName("rb-chart-con")[0];
        wrapper.innerHTML = "";
        let con = document.createElement("div");
        wrapper.appendChild(con);
        con.id = "rechart";
        this.initrightchart(res.data.trend, con);
      });

      let params2 = {
        keyword: e,
        count: 3,
        category: this.actcat,
        foundation: this.actitem,
      };

      getauthor(params2).then((res) => {
        console.log(res, "---667");
        this.rbauthor = res.data;
      });
    },
    changeccf(e) {
      this.isccf = true;
      let cloudlist = [];
      if (this.isccf) {
        cloudlist = this.leftdata.CCF.word_cloud;
      } else {
        cloudlist = this.leftdata.IEEE.word_cloud;
      }
      // console.log(this.leftdata,'---278')
      setTimeout(() => {
        for (let i = 0; i < cloudlist.length; i++) {
          let str = "cloudEl";
          let el = document.getElementById(str);
          let newclouddata = cloudlist[i].splice(0, 39);
          this.drawCloud(el, newclouddata);
          // console.log(newclouddata,'---477')
        }
      }, 500);
    },
    drawtreeCloud(wrapEl, data) {
      let maskImage = new Image(); //可以根据图片形状生成有形状的词云图
      maskImage.src = this.cloudpng64;
      // let list = [];
      // for (let i in data) {
      //   list.push({
      //     name: i,
      //     value: data[i],
      //   });
      // }
      // if (list.length == 0) {
      //   list = [{ name: "无", value: 50 }];
      // }
      console.log(maskImage, "----1526");
      let myChart = echarts.init(wrapEl);
      let option = {
        tooltip: {
          // backgroundColor:'#fff',
          show: true,
        },
        // backgroundColor:'#fff', // 画布背景色
        series: [
          {
            name: "热词",
            type: "wordCloud",
            maskImage: maskImage, // 图片形状
            keepAspect: false,
            sizeRange: [5, 15], //画布范围，如果设置太大会出现少词（溢出屏幕）
            rotationRange: [-45, 0, 45, 90], //数据翻转范围
            // shape: "circle",
            drawOutOfBound: false, // 超出画布的词汇是否隐藏
            drawOutOfBound: false,
            color: "#fff",
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            width: "100%",
            height: "100%",
            gridSize: 1,
            textPadding: 1,
            autoSize: {
              enable: true,
              minSize: 10,
            },
            textStyle: {
              normal: {
                fontFamily: "sans-serif",
                fontWeight: "bold",
                // color: "#333", // 字体颜色
                color: function () {
                  // 字体颜色
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                    ].join(",") +
                    ")"
                  );
                },
              },
              emphasis: {
                // focus: 'self',
                textStyle: {
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
            },
            data: data,
          },
        ],
      };
      maskImage.onload = function() {
      let that = this;
      myChart.setOption(option, true);
      console.log(myChart, "---495");
      myChart.on("click", function (e) {
        console.log(e, "----401");
        that.clickwordcloud(e.data.name);
      });
      };
    },
    drawCloud(wrapEl, data) {
      // let maskImage = new Image(); //可以根据图片形状生成有形状的词云图
      // maskImage.src= this.bgImg;
      let list = [];
      for (let i in data) {
        list.push({
          name: i,
          value: data[i],
        });
      }
      // console.log(list,'---310')
      if (list.length == 0) {
        list = [{ name: "无", value: 50 }];
      }
      let myChart = echarts.init(wrapEl);
      let option = {
        tooltip: {
          show: true,
        },
        // backgroundColor:'#fff', // 画布背景色
        series: [
          {
            name: "热词",
            type: "wordCloud",
            // maskImage: maskImage, // 图片形状
            keepAspect: false,
            sizeRange: [10, 40], //画布范围，如果设置太大会出现少词（溢出屏幕）
            rotationRange: [0, 10], //数据翻转范围
            // shape: "circle",
            // drawOutOfBound: true, // 超出画布的词汇是否隐藏
            drawOutOfBound: false,
            color: "#fff",
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            // width: "100%",
            height: "100%",
            gridSize: 8,
            textPadding: 10,
            autoSize: {
              enable: true,
              minSize: 6,
            },
            textStyle: {
              normal: {
                fontFamily: "sans-serif",
                fontWeight: "bold",
                // color: "#333", // 字体颜色
                color: function () {
                  // 字体颜色
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                    ].join(",") +
                    ")"
                  );
                },
              },
              emphasis: {
                // focus: 'self',
                textStyle: {
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
            },
            data: list,
          },
        ],
      };
      // maskImage.onload = function() {
      let that = this;
      myChart.setOption(option, true);
      console.log(myChart, "---495");
      myChart.on("click", function (e) {
        console.log(e, "----401");
        that.clickwordcloud(e.data.name);
      });
      // };
    },
    changetab(e) {
      this.tabindex = e;
      // this.mapid = 1;
      let index = this.mapid - 1;
      this.$nextTick(function () {
        if (index == 0) {
          // this.changemapdata(mapData1);
          this.initdemodata(demo, index);
        } else if (index == 1) {
          // this.changemapdata(mapData2);
          this.initdemodata(demo2, index);
        } else if (index == 2) {
          // this.changemapdata(mapData3);
          this.initdemodata(demo3, index);
        } else if (index == 3) {
          // this.changemapdata(mapData4);
          this.initdemodata(demo4, index);
        } else if (index == 4) {
          // this.changemapdata(mapData5);
          this.initdemodata(demo5, index);
        } else if (index == 5) {
          // this.changemapdata(mapData6);
          this.initdemodata(demo6, index);
        } else if (index == 6) {
          // this.changemapdata(mapData7);
          this.initdemodata(demo7, index);
        }

        if (e == 3) {
          this.getBase64(cloudpng,demo,index+1)
          
        }
        
      });
    },
    getBase64(imgUrl,data,index) {
      window.URL = window.URL || window.webkitURL;
      var xhr = new XMLHttpRequest();
      xhr.open("get", imgUrl, true);
      xhr.responseType = "blob";
      let that = this;
      xhr.onload = function () {
        if (this.status == 200) {
          //得到一个blob对象
          var blob = this.response;
          // 至关重要
          let oFileReader = new FileReader();
          
          oFileReader.onloadend = function (e) {
            // 此处拿到的已经是base64的图片了,可以赋值做相应的处理
            // console.log(e.target.result)
            that.cloudpng64 = e.target.result;
            console.log(index,data)
            if (index == 0) {
              that.inittreeclouddata(data,index)
            } else if (index == 1) {
              that.inittreeclouddata(data,index)
            } else if (index == 2) {
              that.inittreeclouddata(data,index)
            } else if (index == 3) {
              that.inittreeclouddata(data,index)
            } else if (index == 4) {
              that.inittreeclouddata(data,index)
            } else if (index == 5) {
              that.inittreeclouddata(data,index)
            } else if (index == 6) {
              that.inittreeclouddata(data,index)
            }
            // let value = [
            //   {
            //     name: "花鸟市场",
            //     value: 1446,
            //   },
            //   {
            //     name: "汽车",
            //     value: 928,
            //   },
            //   {
            //     name: "视频",
            //     value: 906,
            //   },
            //   {
            //     name: "电视",
            //     value: 825,
            //   },
            //   {
            //     name: "Lover Boy 88",
            //     value: 514,
            //   },
            // ];
            // let ele = document.getElementById("cloudtreeEl");
            // that.drawtreeCloud(ele, value);
          };
          oFileReader.readAsDataURL(blob);
        }
      };
      xhr.send();
    },
    exchange(e, cat, foundation) {
      console.log(e, cat, "---184");
      let listindex;
      for (let i = 0; i < this.showlist.length; i++) {
        if (this.showlist[i].name == cat) {
          for (let j = 0; j < this.showlist[i].list.length; j++) {
            if (this.showlist[i].list[j].name == e[0].keyword) {
              listindex = [i, j];
            }
          }
        }
      }
      if (this.showlist[listindex[0]].list[listindex[1]].value) {
        this.showlist[listindex[0]].list[listindex[1]].value = false;
        let fund;
        if (this.yearindex == 0) {
          fund = "title";
        } else if (this.yearindex == 1) {
          fund = "abstract";
        } else {
          fund = "keyword";
        }

        var formdata = new FormData();
        formdata.append("keyword", e[0].keyword);
        formdata.append("fund", fund);
        formdata.append("catergory", cat);
        let params = {
          keyword: e[0].keyword,
          fund: fund,
          category: cat,
          type: "信息科学部",
          foundation: foundation,
        };

        getchart(params).then((res) => {
          console.log(res, "---98");
          let classnamez = "tablecontz" + e[0].id;
          let classnamezhu = "tablecontzhu" + e[0].id;
          this.$nextTick(function () {
            let container = document.getElementsByClassName(classnamez)[0];
            let containerzhu = document.getElementsByClassName(classnamezhu)[0];
            console.log(container, "---213");
            let ratiodata = [];
            for (let i = 0; i < res.data.Ratio_paperNum.length; i++) {
              ratiodata.push({
                name: res.data.Ratio_paperNum[i].name,
                Ratio: Number(res.data.Ratio_paperNum[i].Ratio),
                Paper_Num: res.data.Ratio_paperNum[i].Paper_Num,
              });
            }
            this.initzchart(ratiodata, container);
            let zhudata = [];
            for (let i = 0; i < res.data.Trend.length; i++) {
              zhudata.push({
                name: res.data.Trend[i].name,
                trend: +res.data.Trend[i].Trend.substring(
                  0,
                  res.data.Trend[i].Trend.length - 1
                ),
              });
            }
            this.initzhuchart(zhudata, containerzhu);
          });
        });

        let params2 = {
          keyword: e[0].keyword,
          count: 3,
          category: cat,
          foundation: foundation,
        };

        getauthor(params2).then((res) => {
          console.log(res, "---448");
          this.tableauthor = res.data;
        });
      } else {
        this.showlist[listindex[0]].list[listindex[1]].value = true;
      }
      console.log(this.showlist, "---454");
    },
    initrightchart(data, container) {
      this.rightchart = new Chart({
        container: container,
        autoFit: true,
        height: 150,
      });

      this.rightchart.data(data);
      this.rightchart.scale({
        date: {
          alias: "日期",
          type: "year",
        },
        Ratio: {
          alias: "占比(%)",
          min: 0,
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: false,
        },
      });

      this.rightchart.axis("ratio", {
        grid: null,
        title: {},
      });

      this.rightchart.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      this.rightchart.line().position("year*ratio").color("#4FAAEB");

      this.rightchart.render();
    },
    initzchart(data, container) {
      const chart = new Chart({
        container: container,
        autoFit: true,
        height: 500,
      });

      chart.data(data);
      chart.scale({
        date: {
          alias: "日期",
          type: "time",
        },
        Ratio: {
          alias: "占比(%)",
          min: 0,
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: false,
        },
        Paper_Num: {
          alias: "基金",
          min: 0,
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: true,
        },
      });

      chart.axis("ratio", {
        grid: null,
        title: {},
      });
      chart.axis("paper number", {
        title: {},
      });

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      chart.line().position("name*Ratio").color("#4FAAEB");
      chart.line().position("name*Paper_Num").color("#9AD681").shape("dash");

      chart.render();
    },
    clickshowratio() {
      this.showranktable = false;
    },
    clickshowratio2() {
      this.showranktable = true;
    },
    initzhuchart(data, container) {
      const chart = new Chart({
        container: container,
        autoFit: true,
        height: 500,
      });
      // console.log(data, "---377");
      chart.data(data);

      chart.scale("trend", {
        alias: "趋势(%)",
        nice: true,
      });
      chart.axis("trend", {
        label: null,
        title: {
          offset: 30,
        },
      });
      chart.tooltip({
        showMarkers: false,
        formatter: function (val) {
          var tipText = "";
          tipText +=
            val[0].name +
            " : " +
            "<br/>" +
            val[0].seriesName +
            " : " +
            val[0].value +
            "<br/>" +
            val[1].seriesName +
            " : " +
            val[1].value +
            "%<br/>";
          return tipText;
        },
      });
      chart.interaction("active-region");
      chart.legend(false);
      chart.interval().position("name*trend");

      chart.render();
    },
    changeyear(e) {
      this.yearindex = e;
      // this.leftdata = this.alldata[e];
      this.isccf = true;
      if (e == 0) {
        localStorage.setItem("hotkeyfund", "title");
        window.location.reload();
      } else if (e == 1) {
        localStorage.setItem("hotkeyfund", "abstract");
        window.location.reload();
      } else {
        localStorage.setItem("hotkeyfund", "keyword");
        window.location.reload();
      }
    },
    handleleftsec(e, index) {
      this.leftindex = index;
      this.showfixed = true;
      this.actitem = e;
      this.mapid = index + 1;
      this.actcat = e;
      this.showwordcloud = false;
      let fund;
      if (this.yearindex == 0) {
        fund = "title";
      } else if (this.yearindex == 1) {
        fund = "abstract";
      } else if (this.yearindex == 2) {
        fund = "keyword";
      }
      this.getdata(fund, e, e, false);
      console.log(e, index, "----900");
      if (index == 0) {
        // this.changemapdata(mapData1);
        this.initdemodata(demo, index);
      } else if (index == 1) {
        // this.changemapdata(mapData2);
        this.initdemodata(demo2, index);
      } else if (index == 2) {
        // this.changemapdata(mapData3);
        this.initdemodata(demo3, index);
      } else if (index == 3) {
        // this.changemapdata(mapData4);
        this.initdemodata(demo4, index);
      } else if (index == 4) {
        // this.changemapdata(mapData5);
        this.initdemodata(demo5, index);
      } else if (index == 5) {
        // this.changemapdata(mapData6);
        this.initdemodata(demo6, index);
      } else if (index == 6) {
        // this.changemapdata(mapData7);
        this.initdemodata(demo7, index);
      }

      // this.getmapdata(mapData1);
      // let dom = document.getElementsByClassName(e)[0].offsetTop;
      // window.scrollTo(0, dom + 141);
    },
    handlealmitem(cat, found) {
      this.actitem = found;
      this.showfixed = false;
      this.showwordcloud = true;
      this.actcat = cat;
      let fund;
      if (this.yearindex == 0) {
        fund = "title";
      } else if (this.yearindex == 1) {
        fund = "abstract";
      } else if (this.yearindex == 2) {
        fund = "keyword";
      }
      this.getdata(fund, cat, found, false);
    },
    gotop() {
      window.scrollTo(0, 0);
    },
    getdata(e, cat, found, readmore) {
      let params = {
        fund: e,
        cat: cat,
        foundation: found,
        readmore: readmore,
      };
      // console.log(params,'---606')
      getfilter(params).then((res) => {
        // this.alldata = res.data;
        this.leftdata = res.data;
        this.nsfcdata = res.data.rank_num;
        // console.log(this.leftdata,'---537')
        let cloudlist = [];
        this.showlist = [];
        cloudlist.push(this.leftdata.word_cloud);
        let showlistitem = [];
        for (let j = 0; j < this.leftdata.rank.length; j++) {
          showlistitem.push({
            name: this.leftdata.rank[j].keyword,
            value: true,
          });
        }
        this.showlist.push({
          name: this.leftdata.category,
          list: showlistitem,
        });
        // console.log(this.showlist,'---604')
        // if (this.isccf) {
        //   cloudlist = this.leftdata.CCF.word_cloud;
        // } else {
        //   cloudlist = this.leftdata.IEEE.word_cloud;
        // }
        let con = document.getElementsByClassName("cloud-con")[0];
        con.innerHTML = "";

        this.$nextTick(function () {
          for (let i = 0; i < cloudlist.length; i++) {
            let el = document.createElement("div");
            el.id = "cloudEl";
            el.className = "cloud-box";
            con.appendChild(el);

            console.log(cloudlist[i], "---477");
            this.drawCloud(el, cloudlist[i]);
          }
        });
        // this.rightdata = res.data[2].
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
.archive-main {
  background: #f0f2f5;
  padding: 20px 15px;
  min-height: 100vh;
}
.arm-head {
  width: 100%;
  padding: 0 20px;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  color: #0275d8;
  font-weight: bold;
  margin-bottom: 20px;
  img {
    vertical-align: middle;
  }
}
.almb-sec-act {
  color: #0275d8;
  background-color: #e5f1fb;
  border-left: #0275d8 3px solid;
}
.arm-head-btn {
  display: inline-block;
  cursor: pointer;
  width: 52px;
  height: 30px;
  line-height: 30px;
  margin-left: 5px;
  border-radius: 5px;
  background-color: #f0f2f5;
  text-align: center;
  color: #0275d8;
}
.arm-head-btn-act {
  background-color: #337ab7;
  color: #fff;
}
.arm-body {
  width: 100%;
  display: flex;
  position: relative;
}
.arm-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 250px;
}
.arm-left-main {
  width: 250px;
  background-color: #fff;
  border-radius: 5px;
}
.arm-left-main-fixed {
  position: fixed;
  top: 0;
  left: 15px;
}
.arm-left-main-fixed .alm-body {
  height: calc(100vh - 64px);
  overflow: hidden;
  overflow-y: auto;
}
.arm-right {
  flex: 1;
  margin-left: 270px;
}
.alm-titile {
  width: 100%;
  display: flex;
  font-size: 15px;
}
.green {
  color: #8fbc8f;
}
.red {
  color: #db7093;
}
.almt-sec {
  flex: 1;
  text-align: center;
  cursor: pointer;
  height: 42px;
  line-height: 42px;
  font-weight: bold;
}
.alm-body {
  width: 100%;
}
.almb-sec {
  width: 100%;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}
.almb-sec:hover {
  color: #337ab7;
}
.armr-top {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
}
.armrt-head {
  padding: 15px;
  border-bottom: #f0f0f0 1px solid;
  font-size: 15px;
  overflow: hidden;
  span {
    display: inline-block;
    border-left: #0275d8 3px solid;
    padding-left: 10px;
    font-weight: bold;
    line-height: 15px;
  }
}
.armrt-body {
  padding: 15px;
  font-size: 14px;
  .armrt-a {
    color: #46b8da;
    cursor: pointer;
    display: inline-block;
  }
}
.armr-main {
  width: 100%;
  margin-top: 20px;
  border-radius: 5px;
  background-color: #fff;
}
.almt-sec-act {
  color: #337ab7;
}
.gotop-btn {
  position: fixed;
  bottom: 50px;
  right: 100px;
  cursor: pointer;
}
.zchart {
  height: 200px;
  width: 350px;
  margin-right: 30px;
  display: inline-block;
}
.cloud-con {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 300px;
  background-color: #fff;
}

.cloud-box {
  width: 100%;
  height: 300px;
}
.showcloud {
  z-index: 100;
}
.almb-sec-list {
  padding-left: 25px;
}
.almbsl-item {
  cursor: pointer;
}
.almbsl-item-act {
  color: #0275d8;
}
.bottomspan {
  padding: 5px;
  display: inline-block;
}
.table-bottom {
  width: 100%;
  padding: 10px;
  overflow: hidden;
  .armrt-h-right {
    float: right;
  }
}
.right-box {
  position: fixed;
  top: 50px;
  right: 20px;
  width: 600px;
  background-color: #fff;
  border-radius: 16px;
  z-index: 100000000;
  padding: 20px;
  box-shadow: 1px 1px 3px 3px #e1e1e1;
}
.rb-title {
  font-size: 16px;
  font-weight: bold;
  color: #337ab7;
  overflow: hidden;
}
.rb-funds {
  width: 100%;
  height: 300px;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 10px;
}
.rb-f-item {
  margin-bottom: 5px;
}
.rb-liter {
  width: 100%;
  max-height: 150px;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 10px;
}
.rb-author-item {
  display: inline-block;
  margin-right: 10px;
}
.rb-fi-title {
  font-size: 13px;
  font-weight: bold;
  // cursor: pointer;
}
.rb-fi-abs {
  font-size: 12px;
}
.rb-close {
  float: right;
  font-size: 16px;
  color: black;
  cursor: pointer;
}
.cloudwrapper {
  width: 100%;
  position: relative;
}
.cloud-fixed {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 5000;
}
.cloud-fixed-tab {
  display: inline-block;
  margin-left: 5px;
}
</style>
<style lang="less">
.cloud-box {
  width: 100%;
  height: 300px;
}
.cloud-block {
  width: 100%;
  height: 300px;
}
#containernew {
  width: 100%;
  height: 600px;
}
.bluebtn {
  background-color: #337ab7 !important;
  color: white !important;
}
.table-author {
  margin-top: 10px;
}
.table-author-item span {
  position: relative;
  display: inline-block;
  z-index: 1000;
}
.table-author-item span:hover .tai-keyword {
  display: inline-block;
}
.rb-author-item span {
  position: relative;
  display: inline-block;
  z-index: 1000;
}
.rb-author-item span:hover .tai-keyword {
  display: inline-block;
}

.tai-keyword {
  position: absolute;
  z-index: 99;
  width: 150px;
  left: 100%;
  top: 0;
  border-radius: 5px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: none;
}
.newcircle-wrap {
  width: 100%;
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
}
.newcircle {
  width: 1200px;
  margin: 0 auto;
  height: 800px;
  position: relative;
}
.bluebtn {
  background-color: #337ab7 !important;
  color: white !important;
}
.table-author {
  margin-top: 10px;
}
.newcircle-item {
  width: 33%;
  height: 200px;
  display: inline-block;
  position: absolute;
}
.newcircle-itemdot {
  width: 33%;
  height: 200px;
  display: inline-block;
  position: absolute;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  line-height: 200px;
  color: rgb(16, 16, 218);
}
.cloudtreeEl {
  width: 100%;
}
.cloudtree-con {
  width: 990px;
  height: 600px;
  margin: 0 auto;
  position: relative;
}
.cloudtree-box{
  position: absolute;
  width: 25%;
  height: 150px;
  background-image: url(./cloudbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 10;
  // background-position: 40% 40%;
}
.cloudtree-box:nth-child(1){
  top: 50px;
  left: 15%;
  width: 20%;
  height: 100px;
}
.cloudtree-box:nth-child(2){
  top: 170px;
  left: 0;
  width: 20%;
  height: 100px;
}
.cloudtree-box:nth-child(3){
  top: 280px;
  left: 5%;
}
.cloudtree-box:nth-child(4){
  top: 430px;
  left: 15%;
  width: 20%;
  height: 130px;
}
.cloudtree-box:nth-child(5){
  top: 0px;
  right: 10%;
}
.cloudtree-box:nth-child(6){
  top: 150px;
  right: 5%;
}
.cloudtree-box:nth-child(7){
  top: 300px;
  right: 3%;
  width: 15%;
  height: 100px;
}
.cloudtree-box:nth-child(8){
  top: 400px;
  right: 13%;
  width: 20%;
  height: 120px;
}
.cloudline{
  position: absolute;
}
.cloudline:nth-child(1){
  top: 120px;
  left: 25%;
}
.cloudline:nth-child(2){
  top: 120px;
  left: 20%;
}
.cloudline:nth-child(3){
  top: 120px;
  left: 20%;
}
.cloudline:nth-child(4){
  top: 300px;
  left: 20%;
}
.cloudline:nth-child(5){
  top: 120px;
  right: 20%;
}
.cloudline:nth-child(6){
  top: 120px;
  right: 20%;
}
.cloudline:nth-child(7){
  top: 220px;
  right: 15%;
}
.cloudline:nth-child(8){
  top: 300px;
  right: 20%;
}
.cloudtree-center{
  position: absolute;
  width: 30%;
  left: 35%;
  top: 40%;
  height: 150px;
  font-size: 20px;
  color: #0275d8;
  text-align: center;
  line-height: 150px;
  background-size: 100% 100%;
  background-image: url(./cloud.png);
}
</style>


// WEBPACK FOOTER //
// src/pages/nsfcdemo/index.vue